import React from 'react';
export function UsersRoles() {
  return <div data-id="element-2488">
      <div className="flex justify-between items-center mb-6" data-id="element-2489">
        <h1 className="text-2xl font-bold" data-id="element-2490">Users & Roles</h1>
        <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700" data-id="element-2491">
          Add User
        </button>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-2492">
        <table className="min-w-full divide-y divide-neutral-200" data-id="element-2493">
          <thead className="bg-neutral-50" data-id="element-2494">
            <tr data-id="element-2495">
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2496">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2497">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2498">
                Role
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2499">
                Status
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 uppercase tracking-wider" data-id="element-2500">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-neutral-200" data-id="element-2501">
            <tr data-id="element-2502">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2503">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2504">
                  Admin User
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2505">
                <div className="text-sm text-neutral-500" data-id="element-2506">
                  admin@example.com
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2507">
                <div className="text-sm text-neutral-500" data-id="element-2508">Administrator</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2509">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-2510">
                  Active
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-2511">
                <button className="text-blue-600 hover:text-blue-900 mr-2" data-id="element-2512">
                  Edit
                </button>
                <button className="text-red-600 hover:text-red-900" data-id="element-2513">
                  Deactivate
                </button>
              </td>
            </tr>
            <tr data-id="element-2514">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2515">
                <div className="text-sm font-medium text-neutral-900" data-id="element-2516">
                  Broker User
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2517">
                <div className="text-sm text-neutral-500" data-id="element-2518">
                  broker@example.com
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2519">
                <div className="text-sm text-neutral-500" data-id="element-2520">Broker</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-2521">
                <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-2522">
                  Active
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-neutral-500" data-id="element-2523">
                <button className="text-blue-600 hover:text-blue-900 mr-2" data-id="element-2524">
                  Edit
                </button>
                <button className="text-red-600 hover:text-red-900" data-id="element-2525">
                  Deactivate
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}